export default __webpack_public_path__ + "static/media/logo_facebook_white.82b5a10f.svg";